import { Directive, ElementRef, Input } from '@angular/core';
import { AlcmeonContextService } from 'src/app/core/alcmeon-context/alcmeon-context.service';

@Directive({
  selector: '[appJwtSrc]',
})
export class JwtSrcDirective {
  cdnStartPattern = 'cdn';

  constructor(private elRef: ElementRef, private alcmeonContext: AlcmeonContextService) {}

  // thanks https://stackoverflow.com/a/44686085 for the nice idea of using a setter to watch changes
  @Input() set appJwtSrc(src: string) {
    if (src) {
      const u = new URL(src);
      // don't add jwt if url is cdn
      if (u.hostname.startsWith(this.cdnStartPattern)) {
        this.elRef.nativeElement.setAttribute('src', src);
      } else {
        this.alcmeonContext.addJwtShortToUrl(src).subscribe(urlWithJwt => {
          this.elRef.nativeElement.setAttribute('src', urlWithJwt);
        });
      }
    }
  }
}
